import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 初始状态
    count: 0
  },
  modules: {
    auth
  },
  mutations: {
    // 状态变更方法
    increment(state) {
      state.count++
    }
  },
  actions: {
    // 异步操作
    incrementAsync({ commit }) {
      setTimeout(() => {
        commit('increment')
      }, 1000)
    }
  }
})